<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mirror-on`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M31 4.493a1 1 0 01.38.075l12 4.939a1 1 0 01.62.924v26.93a1 1 0 01-.607.92l-12 5.124a1 1 0 01-1.393-.92V5.494a1 1 0 011-1zm-14 0a1 1 0 01.993.883l.007.117v36.993a1 1 0 01-1.283.959l-.11-.04-12-5.124a1 1 0 01-.6-.8L4 37.36V10.43a1 1 0 01.511-.872l.108-.052 12-4.939A1 1 0 0117 4.493zM25 6a1 1 0 011 1v34a1 1 0 01-1 1h-2a1 1 0 01-1-1V7a1 1 0 011-1h2zm9 3.972v27.97l6-2.562V12.44l-6-2.468zm-20 0L8 12.44v22.94l6 2.561V9.972z"/></svg>
</template>
<script>

export default {
  name: 'IconMirrorOn',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
